import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

type GroupedGuidedAdvancedDetailsProps = {
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
  summaryLabel?: string;
  children: React.ReactNode;
};

/** Epic 93f — collapsible advanced audit / ops diagnostics for grouped review. */
export function GroupedGuidedAdvancedDetails({
  expanded,
  onExpandedChange,
  summaryLabel = 'Advanced details',
  children,
}: GroupedGuidedAdvancedDetailsProps) {
  return (
    <Accordion
      expanded={expanded}
      onChange={(_, nextExpanded) => onExpandedChange(nextExpanded)}
      disableGutters
      data-testid="grouped-guided-advanced-accordion"
      sx={{
        borderRadius: '12px !important',
        border: '1px solid #d0d7e2',
        '&:before': { display: 'none' },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={{ fontWeight: 700 }}>{summaryLabel}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ px: 2, pb: 2 }}>{children}</AccordionDetails>
    </Accordion>
  );
}
